export const CPT_CODES_OT = [
    { code: 97165, label: 'Occupational therapy evaluation, low complexity' },
    {
        code: 97166,
        label: 'Occupational therapy evaluation, moderate complexity',
    },
    { code: 97167, label: 'Occupational therapy evaluation, high complexity' },
    {
        code: 97168,
        label: 'Occupational therapy re-evaluation (for ongoing plan of care)',
    },

    {
        code: 97530,
        label:
            'Therapeutic activities, direct (one-on-one) patient contact, each 15 minutes',
    },
    {
        code: 97533,
        label:
            'Sensory integrative techniques to enhance sensory processing, each 15 minutes',
    },
    { code: 97535, label: 'Self-care/home management training, each 15 minutes' },
    {
        code: 97537,
        label: 'Community/work reintegration training, each 15 minutes',
    },
    {
        code: 97150,
        label: 'Therapeutic procedure(s), group (2 or more), untimed',
    },
    {
        code: 97112,
        label:
            'Neuromuscular reeducation of movement, balance, coordination, kinesthetic sense, posture, and/or proprioception',
    },
    { code: 97116, label: 'Gait training (includes stair climbing)' },
    {
        code: 97124,
        label: 'Massage, including effleurage, petrissage, and/or tapotement',
    },
    { code: 97542, label: 'Wheelchair management, each 15 minutes' },
    {
        code: 97550,
        label:
            'Caregiver training in strategies and techniques, face to face; initial 30 minutes',
    },

    {
        code: 97750,
        label: 'Physical performance test or measurement, each 15 minutes',
    },
    {
        code: 97755,
        label:
            'Assistive technology assessment, direct one-on-one, with written report, each 15 minutes',
    },
];



export const CPT_CODES_BCBA = [
    { code: 97151, label: 'Behavior identification assessment' },
    { code: 97152, label: 'Supporting assessment' },
    { code: 97153, label: 'Adaptive behavior treatment, 15 minutes' },
    { code: 97154, label: 'Group adaptive behavior treatment' },
    { code: 97155, label: 'Protocol modification' },
    { code: 97156, label: 'Family adaptive behavior guidance' },
    { code: 97157, label: 'Multiple-family behavior guidance' },
    { code: 97158, label: 'Group adaptive behavior treatment, multiple clients' },
];


export const CPT_CODES_SLP = [
    { code: 92521, label: 'Speech fluency evaluation' },
    { code: 92522, label: 'Speech sound production evaluation' },
    { code: 92523, label: 'Speech production + language evaluation' },
    { code: 92524, label: 'Voice and resonance evaluation' },
    { code: 92507, label: 'Speech therapy treatment, individual' },
    { code: 92508, label: 'Speech therapy treatment, group' },
    { code: 92526, label: 'Swallowing therapy' },
];



export const CPT_CODES_PSYCHOLOGY = [
    { code: 90791, label: 'Psychiatric diagnostic evaluation' },
    { code: 90832, label: 'Psychotherapy, 30 minutes' },
    { code: 90834, label: 'Psychotherapy, 45 minutes' },
    { code: 90837, label: 'Psychotherapy, 60 minutes' },
    { code: 90846, label: 'Family psychotherapy (without patient)' },
    { code: 90847, label: 'Family psychotherapy (with patient)' },
    { code: 90853, label: 'Group psychotherapy' },
    { code: 96130, label: 'Psych testing evaluation, first hour' },
    { code: 96131, label: 'Psych testing evaluation, each addl hour' },
    { code: 96136, label: 'Test administration, first 30 minutes' },
    { code: 96137, label: 'Test administration, each addl 30 minutes' },
];



export const CPT_CODES_PT = [
    { code: 97161, label: 'PT evaluation, low complexity' },
    { code: 97162, label: 'PT evaluation, moderate complexity' },
    { code: 97163, label: 'PT evaluation, high complexity' },
    { code: 97164, label: 'PT re-evaluation' },
    { code: 97110, label: 'Therapeutic exercise, 15 minutes' },
    { code: 97112, label: 'Neuromuscular reeducation, 15 minutes' },
    { code: 97116, label: 'Gait training, 15 minutes' },
    { code: 97140, label: 'Manual therapy, 15 minutes' },
    { code: 97530, label: 'Therapeutic activities, 15 minutes' },
    { code: 97535, label: 'Self-care/home management, 15 minutes' },
];


export const CPT_CODES_NURSE = [
    { code: 99202, label: 'E/M new patient' },
    { code: 99203, label: 'E/M new patient' },
    { code: 99211, label: 'Nurse office visit, minimal' },
    { code: 99212, label: 'E/M established patient, low complexity' },
    { code: 99213, label: 'E/M established patient, moderate complexity' },
    { code: 98960, label: 'Education & training, individual, 30 minutes' },
    { code: 98961, label: 'Education & training, 2–4 patients, 30 minutes' },
    { code: 98962, label: 'Education & training, 5–8 patients, 30 minutes' },
];



export const CPT_CODES_ART_THERAPIST = [
    { code: 90791, label: 'Psychiatric diagnostic evaluation' },
    { code: 90832, label: 'Psychotherapy, 30 minutes' },
    { code: 90834, label: 'Psychotherapy, 45 minutes' },
    { code: 90837, label: 'Psychotherapy, 60 minutes' },
    { code: 90846, label: 'Family psychotherapy (without patient)' },
    { code: 90847, label: 'Family psychotherapy (with patient)' },
    { code: 90853, label: 'Group psychotherapy' },
];


export const CPT_CODES_RBT = [
    { code: 97151, label: 'Behavior identification assessment' },
    { code: 97152, label: 'Supporting assessment' },
    { code: 97153, label: 'Adaptive behavior treatment, 15 minutes' },
    { code: 97154, label: 'Group adaptive behavior treatment' },
    { code: 97155, label: 'Protocol modification' },
    { code: 97156, label: 'Family adaptive behavior guidance' },
    { code: 97157, label: 'Multiple-family behavior guidance' },
    { code: 97158, label: 'Group adaptive behavior treatment, multiple clients' },
];


export const CPT_CODES_TRAUMA_THERAPIST = [
    { code: 90791, label: 'Psychiatric diagnostic evaluation' },
    { code: 90832, label: 'Psychotherapy, 30 minutes' },
    { code: 90834, label: 'Psychotherapy, 45 minutes' },
    { code: 90837, label: 'Psychotherapy, 60 minutes' },
    { code: 90846, label: 'Family psychotherapy (without patient)' },
    { code: 90847, label: 'Family psychotherapy (with patient)' },
    { code: 90853, label: 'Group psychotherapy' },
    { code: 96130, label: 'Psych testing evaluation, first hour' },
    { code: 96131, label: 'Psych testing evaluation, each addl hour' },
];


export const CPT_CODES_CLASSROOM_AIDE = [
    { code: 98960, label: 'Education & training, individual, 30 minutes' },
    { code: 98961, label: 'Education & training, 2–4 patients, 30 minutes' },
    { code: 98962, label: 'Education & training, 5–8 patients, 30 minutes' },
    { code: 97150, label: 'Group therapeutic procedures (untimed)' },
];


export const CPT_CODES_RESIDENTIAL_STAFF = [
    { code: 98960, label: 'Education & training, individual, 30 minutes' },
    { code: 98961, label: 'Education & training, 2–4 patients, 30 minutes' },
    { code: 98962, label: 'Education & training, 5–8 patients, 30 minutes' },
    { code: 97550, label: 'Caregiver training, initial 30 minutes' },
    { code: 90846, label: 'Family psychotherapy (without patient)' },
];


export const CPT_CODES_SPECIAL_ED_TEACHER = [
    { code: 98960, label: 'Education & training, individual, 30 minutes' },
    { code: 98961, label: 'Education & training, 2–4 patients, 30 minutes' },
    { code: 98962, label: 'Education & training, 5–8 patients, 30 minutes' },
    { code: 97150, label: 'Group therapeutic procedures (untimed)' },
    { code: 97550, label: 'Caregiver training, initial 30 minutes' },
];


// Helper to normalize code to string for consistent comparison
// Exported for use in dropdown components
export const normalizeCPTCode = (code) => String(code);

const getUniqueCPTCodes = (arrays) => {
    const seen = new Set();
    const unique = [];

    arrays.flat().forEach((item) => {
        // Normalize code to string for consistent comparison
        const normalizedCode = normalizeCPTCode(item.code);
        if (!seen.has(normalizedCode)) {
            seen.add(normalizedCode);
            unique.push(item);
        }
    });

    return unique;
};

// Include ALL CPT code arrays in fallback to ensure comprehensive coverage
export const CPT_CODES_FALLBACK = getUniqueCPTCodes([
    CPT_CODES_OT,
    CPT_CODES_BCBA,
    CPT_CODES_SLP,
    CPT_CODES_PSYCHOLOGY,
    CPT_CODES_PT,
    CPT_CODES_NURSE,
    CPT_CODES_ART_THERAPIST,
    CPT_CODES_RBT,
    CPT_CODES_TRAUMA_THERAPIST,
    CPT_CODES_CLASSROOM_AIDE,
    CPT_CODES_RESIDENTIAL_STAFF,
    CPT_CODES_SPECIAL_ED_TEACHER,
]);


export const getCPTCodesBySubrole = (subrole) => {
    if (!subrole) {
        return CPT_CODES_FALLBACK;
    }


    const nonBillingProfessions = [
        'Art Therapist',
        'RBT',
        'Residential Staff',
        'Classroom Aide',
        'Special Education Teacher',
    ];

    if (nonBillingProfessions.includes(subrole)) {
        return CPT_CODES_FALLBACK;
    }

    const subroleMap = {
        'BCBA': CPT_CODES_BCBA,
        'Mental Health Clinician': CPT_CODES_PSYCHOLOGY,
        'Nurse': CPT_CODES_NURSE,
        'Occupational Therapist': CPT_CODES_OT,
        'Physical Therapist': CPT_CODES_PT,
        'Psychologist': CPT_CODES_PSYCHOLOGY,
        'Speech and Language Pathologist': CPT_CODES_SLP,
        'Trauma Therapist': CPT_CODES_TRAUMA_THERAPIST,
    };

    return subroleMap[subrole] || CPT_CODES_FALLBACK;
};


export const getGroupedCPTCodesBySubrole = (subrole) => {
    if (!subrole) {
        return {
            subroleLabel: null,
            subroleCodes: [],
            otherCodes: CPT_CODES_FALLBACK,
        };
    }

    const nonBillingProfessions = [
        'Art Therapist',
        'RBT',
        'Residential Staff',
        'Classroom Aide',
        'Special Education Teacher',
    ];

    // For non-billing professions, show all codes in "Other" section
    if (nonBillingProfessions.includes(subrole)) {
        return {
            subroleLabel: null,
            subroleCodes: [],
            otherCodes: CPT_CODES_FALLBACK,
        };
    }

    const subroleMap = {
        'BCBA': { codes: CPT_CODES_BCBA, label: 'BCBA' },
        'Mental Health Clinician': { codes: CPT_CODES_PSYCHOLOGY, label: 'Mental Health Clinician' },
        'Nurse': { codes: CPT_CODES_NURSE, label: 'Nurse' },
        'Occupational Therapist': { codes: CPT_CODES_OT, label: 'Occupational Therapist' },
        'Physical Therapist': { codes: CPT_CODES_PT, label: 'Physical Therapist' },
        'Psychologist': { codes: CPT_CODES_PSYCHOLOGY, label: 'Psychologist' },
        'Speech and Language Pathologist': { codes: CPT_CODES_SLP, label: 'Speech and Language Pathologist' },
        'Trauma Therapist': { codes: CPT_CODES_TRAUMA_THERAPIST, label: 'Trauma Therapist' },
    };

    const subroleData = subroleMap[subrole];

    if (!subroleData) {
        return {
            subroleLabel: null,
            subroleCodes: [],
            otherCodes: CPT_CODES_FALLBACK,
        };
    }


    const subroleCodes = subroleData.codes || [];


    const subroleCodeNumbers = new Set(
        subroleCodes.map(code => normalizeCPTCode(code.code))
    );
    const otherCodes = CPT_CODES_FALLBACK.filter(
        code => !subroleCodeNumbers.has(normalizeCPTCode(code.code))
    );

    return {
        subroleLabel: subroleData.label,
        subroleCodes,
        otherCodes,
    };
};

